// BuildingStabilityInfoModal.js
import { Modal, ModalHeader, ModalBody, ModalContent } from "@heroui/react";
import BuildingStabilityInfoComponent from './stabilityInfoComponent';

const BuildingStabilityInfoModal = ({ isOpen, onClose, building, unit }: any) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="5xl"
      shouldBlockScroll={true}
      isDismissable={true}
      scrollBehavior="inside"
      backdrop="blur"
      className="p-8"
    >
      <ModalContent className="flex flex-col gap-4 font-normal text-neutral-primary">
        <ModalHeader className="flex flex-row items-center justify-between p-0 font-normal">
          <p>{unit?.id || building?.id} - Stabiliteit Informatie</p>
        </ModalHeader>
        <ModalBody className="px-0">
          <BuildingStabilityInfoComponent
            inspectionInfo={{ ...building?.buildingInspectionInfo, buildingId: building?.id}}
            handleCloseParent={onClose}
            building={building}
            unit={unit}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default BuildingStabilityInfoModal;
